"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointOauthConfigIn = void 0;
class EndpointOauthConfigIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointOauthConfigIn.attributeTypeMap;
    }
}
exports.EndpointOauthConfigIn = EndpointOauthConfigIn;
EndpointOauthConfigIn.discriminator = undefined;
EndpointOauthConfigIn.attributeTypeMap = [
    {
        "name": "authMethod",
        "baseName": "authMethod",
        "type": "Oauth2AuthMethodIn",
        "format": ""
    },
    {
        "name": "clientId",
        "baseName": "clientId",
        "type": "string",
        "format": ""
    },
    {
        "name": "clientSecret",
        "baseName": "clientSecret",
        "type": "string",
        "format": ""
    },
    {
        "name": "extraParams",
        "baseName": "extraParams",
        "type": "{ [key: string]: string; }",
        "format": ""
    },
    {
        "name": "grantType",
        "baseName": "grantType",
        "type": "Oauth2GrantType",
        "format": ""
    },
    {
        "name": "jwtParams",
        "baseName": "jwtParams",
        "type": "ClientSecretJwtParamsIn",
        "format": ""
    },
    {
        "name": "scopes",
        "baseName": "scopes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "tokenUrl",
        "baseName": "tokenUrl",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=EndpointOauthConfigIn.js.map